package pl.decks.personal.pages.ievp.foreword

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import pl.decks.personal.components.layouts.site.SiteLayoutStylesheet
import pl.decks.personal.components.widgets.poissondiskgrid.meshStrokeColor
import pl.decks.personal.components.widgets.poissondiskgrid.meshStrokeWidth
import pl.decks.personal.extensions.toSitePalette
import pl.decks.personal.pages.ievp.IEVPStylesheet
import pl.decks.personal.styles.SiteLayout

private val REASONS = listOf(
    "Dual-use - valuable at peace, required at war",
    "Unique technology that requires vast processing",
    "Actually unique data that is the real moat",
    "Build for Data Scientists and Analysts",
    "Data AND software AND infrastructure excellency expected",
    "Data challenges that I already faced. And some new ones",
    "Connected to real hardware. Might get to see the satellites",
    "Be curious, have fun, explore but dive deep",
    "Understand the rationale behind everything",
    "Team with people that elevate you and contribute yourself",
    "Take ownership",
    "Move fast",
    "Big point in European tech sovereignty",
    "Polish founder means shared stakes",
    "I could fit multiple positions posted. The Data Engineer is closest fit",
)

@Composable
fun ICEYEForeword() = Column(
    modifier = SiteLayoutStylesheet.Page.Content.toModifier()
        .padding(left = IEVPStylesheet.Vars.contentPaddingLeft.value(), top = SiteLayout.Space.Medium)
        .gap(SiteLayout.Space.Small)
        .setVariable(meshStrokeColor, ColorMode.current.toSitePalette().accents.secondary.toRgb().copyf(alpha = 0.5f))
        .setVariable(meshStrokeWidth, 3)
        .setVariable(ForewordStylesheet.Vars.pointBackgroundColor, ColorMode.current.toSitePalette().surface)
        .setVariable(ForewordStylesheet.Vars.pointVisitedBackgroundColor, ColorMode.current.toSitePalette().accents.secondary)
        .setVariable(ForewordStylesheet.Vars.pointStrokeColor, meshStrokeColor.value())
    ,
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    CoverLetterText(
        "There's a war right behind the border. I refuse to forget that.",
        """Arms race is just one of the many branches of warfare, though. 
            |Battles are won with data and intel. 
            |My lifetime is at the intersection of both. 
            |When everything breaks, I really want to contribute my best. 
            |That's how I see patriotism.""".trimMargin(),
        """I really hope the times never come. 
            |But hope alone can get you only so far. 
            |Earth Observation is where the advantage is built and data is a means to win it. 
            |Tech sovereignty is non-negotiable and ICEYE is a clear leader with European origin. 
            |Polish roots make it feel like home ground.""".trimMargin(),
        "There's more that aligns:",
    )
    NotesConstellation(REASONS)
    CoverLetterText(
        "I don't care about the role title or the tech stack. The right kind of impact is what I'm after.",
    )
}